import {NgModule} from "@angular/core";
import {SharedModule} from "../../shared.module";
import {AoCartComponent} from "./ao-cart.component";

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        AoCartComponent
    ]
})
export class AoCartModule { }
